import m from "../../geodata/es2015/angolaLow";
window.am4geodata_angolaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/angolaLow.js
// module id = null
// module chunks = 